import { render, staticRenderFns } from "./ContractsRelatory.vue?vue&type=template&id=1046c222&scoped=true"
import script from "./ContractsRelatory.vue?vue&type=script&lang=js"
export * from "./ContractsRelatory.vue?vue&type=script&lang=js"
import style0 from "./ContractsRelatory.vue?vue&type=style&index=0&id=1046c222&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1046c222",
  null
  
)

export default component.exports